import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const containerStyle = {
  width: '100%',
  height: '300px',
  borderRadius: '12px'
};

const MapEmbed = ({ latitude, longitude, businessName }) => {
  const center = {
    lat: latitude,
    lng: longitude
  };

  // Fallback to iframe if API key issues
  if (!GOOGLE_MAPS_API_KEY) {
    return (
      <div 
        className="w-full h-[300px] rounded-xl overflow-hidden bg-slate-100 flex items-center justify-center"
        data-testid="map-fallback"
      >
        <iframe
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: '12px' }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${latitude},${longitude}&zoom=15`}
          title={`Map showing ${businessName}`}
        />
      </div>
    );
  }

  return (
    <div data-testid="google-map">
      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={15}
        >
          <Marker position={center} title={businessName} />
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

// Simple static map for list views
export const StaticMapPreview = ({ latitude, longitude }) => {
  return (
    <div 
      className="w-full h-[150px] rounded-lg overflow-hidden bg-slate-100"
      data-testid="static-map-preview"
    >
      <img
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=14&size=400x200&markers=color:red%7C${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`}
        alt="Map preview"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default MapEmbed;
